var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.973 23.69l18.03-8.95a2.585 2.585 0 013.376 1.007 2.545 2.545 0 01-1.272 3.646L9.032 27.302c-.658.26-1.407.14-1.947-.316l-3.78-3.185a.638.638 0 01.207-1.094l2.426-.827a.653.653 0 01.584.082l2.451 1.728z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    strokeWidth: 1.152,
    d: "M8.973 23.69l18.03-8.95a2.585 2.585 0 013.376 1.007 2.545 2.545 0 01-1.272 3.646L9.032 27.302c-.658.26-1.407.14-1.947-.316l-3.78-3.185a.638.638 0 01.207-1.094l2.426-.827a.653.653 0 01.584.082l2.451 1.728z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9D4F6",
    d: "M15.837 20.219l-4.394-2.169a.639.639 0 01-.024-1.135l1.48-.81c.287-.158.627-.2.945-.114l6.765 1.822-4.772 2.405z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    strokeWidth: 1.152,
    d: "M15.837 20.219l-4.394-2.169a.639.639 0 01-.024-1.135l1.48-.81c.287-.158.627-.2.945-.114l6.765 1.822-4.772 2.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9D4F6",
    d: "M18.385 23.772l-.717 4.943c-.075.516.47.9.935.66l1.935-.992c.292-.151.515-.407.623-.716l2.027-5.823-4.803 1.928z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    strokeWidth: 1.152,
    d: "M18.385 23.772l-.717 4.943c-.075.516.47.9.935.66l1.935-.992c.292-.151.515-.407.623-.716l2.027-5.823-4.803 1.928z"
  }))));
}
export default SvgFlightActive;